import React from 'react';
import { View } from '../../../App';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faChess, faHandshake, faTrophy } from '@fortawesome/free-solid-svg-icons';
import { soundService } from '../../../services/SoundService';
import './QuickNavigationBar.css';

interface QuickNavigationBarProps {
    pushView: (view: View) => void;
}

export const QuickNavigationBar: React.FC<QuickNavigationBarProps> = ({ pushView }) => {
    const handleNavigation = (view: View) => {
        soundService.playClick();
        pushView(view);
    };

    return (
        <div className="quick-navigation-bar">
            <button
                className="quick-nav-button"
                onClick={() => handleNavigation({ type: 'team', title: 'Squad' })}
                title="Go to Squad Management"
            >
                <FontAwesomeIcon icon={faUsers} />
                <span>Squad</span>
            </button>
            <button
                className="quick-nav-button"
                onClick={() => handleNavigation({ type: 'tactics', title: 'Tactics' })}
                title="Go to Tactics Setup"
            >
                <FontAwesomeIcon icon={faChess} />
                <span>Tactics</span>
            </button>
            <button
                className="quick-nav-button"
                onClick={() => handleNavigation({ type: 'transfers', title: 'Transfers' })}
                title="Go to Transfer Market"
            >
                <FontAwesomeIcon icon={faHandshake} />
                <span>Transfers</span>
            </button>
            <button
                className="quick-nav-button"
                onClick={() => handleNavigation({ type: 'competitions', title: 'Competitions' })}
                title="Go to League & Cup Standings"
            >
                <FontAwesomeIcon icon={faTrophy} />
                <span>Competitions</span>
            </button>
        </div>
    );
};
